import { render, staticRenderFns } from "./MeasurementResultPatientDetail.vue?vue&type=template&id=94c383f2&scoped=true&"
import script from "./MeasurementResultPatientDetail.vue?vue&type=script&lang=js&"
export * from "./MeasurementResultPatientDetail.vue?vue&type=script&lang=js&"
import style0 from "./MeasurementResultPatientDetail.vue?vue&type=style&index=0&id=94c383f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c383f2",
  null
  
)

export default component.exports